import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { useMediaQuery } from "@/hooks/use-media-query";
import { useAuth } from "@/contexts/AuthContext";
import { MobileSettingsIndex, navGroups } from "@/components/settings/MobileSettingsIndex";

export const Route = createFileRoute("/dashboard/settings/")({
  component: SettingsIndex,
});

function SettingsIndex() {
  const router = useRouter();
  const { isSuperAdmin } = useAuth();
  const isDesktop = useMediaQuery("(min-width: 768px)");

  useEffect(() => {
    if (!isDesktop) return;
    void router.navigate({ to: "/dashboard/settings/team", replace: true });
  }, [router, isDesktop]);

  if (isDesktop) return null;

  return <MobileSettingsIndex groups={navGroups} isSuperAdmin={isSuperAdmin} />;
}
